export default "__VITE_ASSET__ne9JD8X5__"